import {
  Box,
  Heading,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionIcon,
  AccordionPanel,
  Link
} from '@chakra-ui/react';

const FAQ = () => {
  return (
    <Box
      d="flex"
      flexDirection="column"
      fontSize="md"
      color="gray.500"
      mx="40"
      width="50%"
      w={{ base: 'full', md: '50%' }}
    >
      <Heading
        as="h2"
        size="lg"
        color="primary.800"
        fontWeight="semibold"
        textAlign="center"
        mb="8"
      >
        Frequently Asked Questions
      </Heading>
      <Accordion
        allowToggle
        border="1px solid #ddd"
        borderRadius="md"
        bg="white"
      >
        <AccordionItem>
          <h2>
            <AccordionButton>
              <Box
                flex="1"
                textAlign="left"
                color="primary.800"
                fontWeight="semibold"
              >
                Is there a free version of FontVisual?
              </Box>
              <AccordionIcon />
            </AccordionButton>
          </h2>
          <AccordionPanel pb={4}>
            Yes! You can sign up for our free plan at no cost. Free forever –
            for as long as you would like. <br />
            <br />
            <strong>NOTE:</strong> The Free version only includes in-app font
            preview. You will need to upgrade to the Plus plan to use the
            Showcase feature – for shareable font preview links and embed
            previews.
          </AccordionPanel>
        </AccordionItem>
        <AccordionItem>
          <h2>
            <AccordionButton>
              <Box
                flex="1"
                textAlign="left"
                color="primary.800"
                fontWeight="semibold"
              >
                What payment methods do you accept?
              </Box>
              <AccordionIcon />
            </AccordionButton>
          </h2>
          <AccordionPanel pb={4}>
            We accept all major credit and debit cards such as Visa, Mastercard,
            or American Express, and PayPal. All payment processing is handled
            via{' '}
            <Link href="https://paddle.com" color="primary.600">
              Paddle
            </Link>{' '}
            as the Merchant of Record.
          </AccordionPanel>
        </AccordionItem>

        <AccordionItem>
          <h2>
            <AccordionButton>
              <Box
                flex="1"
                textAlign="left"
                color="primary.800"
                fontWeight="semibold"
              >
                Will I be charged when my trial for Plus plan expires?
              </Box>
              <AccordionIcon />
            </AccordionButton>
          </h2>
          <AccordionPanel pb={4}>
            No. You&apos;ll only be charged when you upgrade and pay for the
            plan. If you don’t upgrade, you won’t be billed, your trial will
            expire automatically, and your account data will be permanently
            deleted.
          </AccordionPanel>
        </AccordionItem>

        <AccordionItem>
          <h2>
            <AccordionButton>
              <Box
                flex="1"
                textAlign="left"
                color="primary.800"
                fontWeight="semibold"
              >
                Can I cancel anytime?
              </Box>
              <AccordionIcon />
            </AccordionButton>
          </h2>
          <AccordionPanel pb={4}>
            Yes. You can cancel your FontVisual account at any time during the
            billing period. You can so do right from your settings - no need to
            contact us (unless you have a question). If you decide to cancel,
            you will keep having access until that billing period ends. You may
            do a full export of your files before cancellation.
          </AccordionPanel>
        </AccordionItem>

        <AccordionItem>
          <h2>
            <AccordionButton>
              <Box
                flex="1"
                textAlign="left"
                color="primary.800"
                fontWeight="semibold"
              >
                What happens when I end my subscription?
              </Box>
              <AccordionIcon />
            </AccordionButton>
          </h2>
          <AccordionPanel pb={4}>
            Once you end your subscription, you will lose access to all files
            and any Showcase pages will no longer be accessible. You may do a
            full export of your files before you cancel or end your
            subscription.
          </AccordionPanel>
        </AccordionItem>

        <AccordionItem>
          <h2>
            <AccordionButton>
              <Box
                flex="1"
                textAlign="left"
                color="primary.800"
                fontWeight="semibold"
              >
                What if I have more questions?
              </Box>
              <AccordionIcon />
            </AccordionButton>
          </h2>
          <AccordionPanel pb={4}>
            Send an email to{' '}
            <Link href="mailto:support@fontvisual.com" color="primary.500">
              support@fontvisual.com
            </Link>{' '}
            and we&apos;ll get back to you as soon as possible.
          </AccordionPanel>
        </AccordionItem>
      </Accordion>
    </Box>
  );
};

export default FAQ;
